import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../sidebar/sidebar";

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          marginLeft: "260px",
          backgroundColor: "#f5f7fa",
          minHeight: "100vh",
          p: 3,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
